<template>
  <div class="menu-list-container">
    <el-row :gutter="20" class="operate-bar">
      <el-col :span="8" align="left">
        <!-- 新增菜单按钮 -->
        <el-button icon="el-icon-plus" type="primary" @click="openAddDialog(null)"
          v-hasPermission="'menu:edit'">新增根菜单</el-button>
      </el-col>
      <!-- 搜索区域 -->
      <el-col :span="16" align="right">
        <el-form :inline="true" class="search-form">
          <el-form-item>
            <el-button icon="el-icon-refresh" style="visibility: hidden;">重置</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>

    <!-- 菜单树形结构 -->
    <el-tree :data="menuTree" node-key="id" :props="treeProps" :expand-on-click-node="false" :default-expand-all="true"
      ref="menuTree" class="menu-tree">
      <span class="custom-tree-node" slot-scope="{ node, data }">
        <span>{{ data.menuName }}</span>
        <span>
          <el-tag size="mini" v-if="data.path" class="mr-2">{{ data.path }}</el-tag>
          <el-tag size="mini" :type="data.menuType === 'M' ? 'success' : 'info'" class="mr-2">
            {{ data.menuType === 'M' ? '目录' : '菜单' }}
          </el-tag>
          <el-button type="text" size="mini" v-hasPermission="'menu:edit'" @click="() => openAddDialog(data.id)">
            <i class="el-icon-plus"></i>
          </el-button>
          <el-button type="text" size="mini" v-hasPermission="'menu:edit'" @click="() => openEditDialog(data)">
            <i class="el-icon-edit"></i>
          </el-button>
          <el-button type="text" size="mini" v-hasPermission="'menu:edit'" @click="() => handleDelete(data)"
            :disabled="hasChildren(data)">
            <i class="el-icon-delete"></i>
          </el-button>
        </span>
      </span>
    </el-tree>


    <!-- 新增/编辑对话框 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="500px">
      <el-form :model="form" :rules="rules" ref="form" label-width="100px">
        <el-form-item label="上级菜单">
          <el-select v-model="form.parentId" placeholder="请选择上级菜单" :disabled="true">
            <el-option :value="0" label="无（根菜单）"></el-option>
            <el-option v-for="menu in flattenMenus(menuTree)" :key="menu.id" :label="getMenuLabel(menu)"
              :value="Number(menu.id)"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="菜单名称" prop="menuName">
          <el-input v-model="form.menuName" maxlength="20" placeholder="请输入菜单名称"></el-input>
        </el-form-item>
        <el-form-item label="路由地址" prop="path">
          <el-input v-model="form.path" placeholder="如/views/system/MenuList.vue" maxlength="100"></el-input>
        </el-form-item>
        <el-form-item label="组件路径" prop="component">
          <el-input v-model="form.component" placeholder="请输入组件路径" maxlength="100"></el-input>
        </el-form-item>
        <el-form-item label="菜单类型" prop="menuType">
          <el-radio-group v-model="form.menuType">
            <el-radio :label="'M'">目录</el-radio>
            <el-radio :label="'C'">菜单</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="菜单图标" prop="icon">
          <el-input v-model="form.icon" placeholder="请输入icon编码" maxlength="100"></el-input>
        </el-form-item>
        <el-form-item label="显示顺序" prop="orderNum">
          <el-input-number v-model="form.orderNum" controls-position="right" :min="0" :max="99"></el-input-number>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="dialogVisible = false; $refs.form.resetFields()">取消</el-button>
        <el-button type="primary" @click="submitForm">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import menuApi from '../../api/menu'
import { hasPermission } from '../../utils/hasPermission'

export default {
  name: 'MenuList',
  data() {
    return {
      // 菜单树形数据
      menuTree: [],

      // 对话框
      dialogVisible: false,
      dialogTitle: '新增菜单',
      isEdit: false,
      form: {
        id: null,
        parentId: 0,
        menuName: '',
        path: '',
        component: '',
        menuType: 'M',
        icon: '',
        orderNum: 0,
        visible: 1,
        status: 1
      },
      rules: {
        menuName: [
          { required: true, message: '请输入菜单名称', trigger: 'blur' },
          { min: 1, max: 20, message: '长度在 1 到 20 个字符', trigger: 'blur' }
        ],
        path: [
          { required: true, message: '请输入路由地址', trigger: 'blur' },
          { min: 1, max: 100, message: '长度在 1 到 100 个字符', trigger: 'blur' }
        ],
        component: [
          { required: false, message: '请输入组件路径', trigger: 'blur' },
          { min: 1, max: 100, message: '长度在 1 到 100 个字符', trigger: 'blur' }
        ],
        menuType: [
          { required: true, message: '请选择菜单类型', trigger: 'change' }
        ],
        icon: [
          { required: false, message: '请输入icon编码', trigger: 'blur' },
          { min: 1, max: 100, message: '长度在 1 到 100 个字符', trigger: 'blur' }
        ],
        orderNum: [
          { required: true, message: '请输入显示顺序', trigger: 'blur' },
          { type: 'number', min: 0, max: 99, message: '请输入在 0 到 99 之间的数字', trigger: 'blur' }
        ]
      },

      // 树形结构配置
      treeProps: {
        children: 'children',
        label: 'menuName'
      }
    }
  },
  created() {
    this.loadMenus()
  },
  methods: {
    // 加载菜单列表
    loadMenus() {
      // 组装请求参数
      const params = {
        isShowAll: 1 // 菜单维护页要显示所有菜单,1为显示所有菜单,0为只显示当前用户的菜单
      };
      menuApi.findAll(params).then(response => {
        if (response.success) {
          // 构建菜单树形结构
          this.menuTree = this.buildMenuTree(response.data.data)
        } else {
          this.$message.error(response.message)
        }
      }).catch(error => {
        this.$message.error('加载菜单失败：' + error.message)
      })
    },
    // 递归扁平化树状结构，返回包含所有节点的一维数组
    flattenMenus(tree) {
      let allMenus = [];
      tree.forEach(node => {
        // 先添加当前节点
        allMenus.push(node);
        // 若有子节点，递归处理并合并
        if (node.children && node.children.length > 0) {
          allMenus = allMenus.concat(this.flattenMenus(node.children));
        }
      });
      return allMenus;
    },

    // 构建菜单树形结构
    buildMenuTree(menus) {
      const tree = []
      const map = {}

      // 先将所有菜单放入map
      menus.forEach(menu => {
        map[menu.id] = { ...menu, children: menu.children || [] }
      })

      // 构建树形结构
      menus.forEach(menu => {
        if (menu.parentId === null || menu.parentId === 0) {
          // 根节点
          tree.push(map[menu.id])
        } else {
          // 子节点
          if (map[menu.parentId]) {
            map[menu.parentId].children.push(map[menu.id])
          }
        }
      })

      return tree
    },

    // 打开新增对话框
    openAddDialog(parentId) {
      if (!hasPermission('menu:edit')) {
        this.$message.error('无新增菜单权限');
        return;
      }
      this.dialogTitle = parentId ? '新增子菜单' : '新增根菜单'
      this.isEdit = false
      this.form = {
        id: null,
        parentId: parentId || 0,
        menuName: '',
        path: '',
        component: '',
        menuType: 'M',
        icon: '',
        orderNum: 0,
        visible: 1,
        status: 1
      }
      this.dialogVisible = true
    },

    // 打开编辑对话框
    openEditDialog(data) {
      if (!hasPermission('menu:edit')) {
        this.$message.error('无编辑菜单权限');
        return;
      }
      this.dialogTitle = '编辑菜单'
      this.isEdit = true
      this.form = { ...data }
      this.dialogVisible = true
    },

    // 提交表单
    submitForm() {
      this.$refs.form.validate(valid => {
        if (valid) {
          if (this.isEdit) {
            // 更新菜单
            menuApi.update(this.form.id, this.form).then(response => {
              if (response.success) {
                this.$message.success(response.message || '更新成功')
                this.dialogVisible = false
                this.loadMenus()
              } else {
                this.$message.error(response.message)
              }
            }).catch(error => {
              this.$message.error('更新失败：' + error.message)
            })
          } else {
            // 新增菜单
            menuApi.add(this.form).then(response => {
              if (response.success) {
                this.$message.success(response.message || '新增成功')
                this.dialogVisible = false
                this.loadMenus()
              } else {
                this.$message.error(response.message)
              }
            }).catch(error => {
              this.$message.error('新增失败：' + error.message)
            })
          }
        }
      })
    },

    // 删除菜单
    handleDelete(data) {
      if (!hasPermission('menu:edit')) {
        this.$message.error('无删除菜单权限');
        return;
      }
      if (this.hasChildren(data)) {
        this.$message.error('该菜单下有子菜单，不能删除');
        return;
      }
      this.$confirm('确定要删除该菜单吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        menuApi.delete(data.id).then(response => {
          if (response.success) {
            this.$message.success(response.message || '删除成功')
            this.loadMenus()
          } else {
            this.$message.error(response.message)
          }
        }).catch(error => {
          this.$message.error('删除失败：' + error.message)
        })
      }).catch(() => {
        // 取消操作（此处可留空，仅用于捕获异常）
      });
    },

    // 判断菜单是否有子菜单
    hasChildren(data) {
      return data.children && data.children.length > 0
    },

    // 获取权限标签（用于下拉选择显示完整路径）
    getMenuLabel(menu, prefix = '') {
      const label = prefix ? `${prefix} > ${menu.menuName}` : menu.menuName

      // 只返回第一层子节点，避免下拉列表过长
      if (!prefix) {
        return label
      }

      return label
    },

    hasPermission(permCode) {
      return hasPermission(permCode);
    },

  }
}
</script>

<style scoped>
.menu-tree {
  min-height: 400px;
  border: 1px solid #EBEEF5;
  border-radius: 4px;
  padding: 10px;
}

.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}

.mr-2 {
  margin-right: 4px;
}
</style>
